import React, { useEffect } from 'react';
import { Box, ProgressCircle } from '@chakra-ui/react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { RoutePath } from '../generic/config';

/** Login is delegated to Keycloak (OIDC code+PKCE). Hitting this route just
 *  kicks off the redirect; an already-signed-in user is sent home. */
const SignInPage: React.FC = () => {
    const auth = useAuth();

    useEffect(() => {
        if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator && !auth.error) {
            void auth.signinRedirect();
        }
    }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.error]);

    if (auth.isAuthenticated) {
        return <Navigate to={RoutePath.Default} replace />;
    }

    return (
        <Box display="flex" justifyContent="center">
            <ProgressCircle.Root value={null} size="lg" mt={"20vh"} color="orange" css={{ "--thickness": "2px" }} />
        </Box>
    );
};

export default SignInPage;
